import { render, staticRenderFns } from "./GExamListTable.vue?vue&type=template&id=db4b0ad4&"
import script from "./GExamListTable.vue?vue&type=script&lang=ts&"
export * from "./GExamListTable.vue?vue&type=script&lang=ts&"
import style0 from "./GExamListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports